export default __webpack_public_path__ + "static/media/turistas-faro-isla-aillaquillen.d3f77f60.jpeg";